import CONF from '../api/config';
import { getState } from '../state/store';

const isBasic = () => getState().app.loggedInUser.isBasic;

export const navigateToMarketplaceAnalytics = {
    path: `${CONF.URL_COACHHEROIC}/marketplace`,
    isAllowed: () => true
};

export const navigateToAthletes = {
    path: `${CONF.URL_COACHHEROIC}/athletes`,
    isAllowed: () => true
};

export const navigateToAccount = {
    path: CONF.URL_ACCOUNT,
    isAllowed: () => true
};

export const navigateToLegacyBilling = {
    path: `${CONF.URL_COACHHEROIC}/settings/billing`,
    isAllowed: () => true
};

export const navigateToBilling = {
    path: `${CONF.URL_ACCOUNT}/billing`,
    isAllowed: () => true
};

export const navigateToCoachHeroic = {
    path: '/',
    isAllowed: () => true
};

export const navigateToLibrary = {
    path: CONF.BASE_URL_LIBRARY,
    isAllowed: () => !isBasic()
};

export const navigateToMarketplace = {
    path: CONF.URL_MARKETPLACE,
    isAllowed: () => true
};

export const navigateToOrgSettings = orgId => {
    window.location.replace(`${CONF.BASE_URL_APP}/teams/org/${orgId}/settings`);
};

export const navigateToReports = {
    path: `${CONF.URL_COACHHEROIC}/reports`,
    isAllowed: () => !isBasic()
};

export const navigateToSettings = {
    path: `${CONF.URL_COACHHEROIC}/settings/designs`,
    isAllowed: () => true
};

export const navigateToSpreadsheets = {
    path: `${CONF.URL_COACHHEROIC}/spreadsheets`,
    isAllowed: () => !isBasic()
};

export const navigateToStandards = {
    path: `${CONF.URL_COACHHEROIC}/standards`,
    isAllowed: () => !isBasic()
};

export const navigateToSubmitFeedback = {
    path: CONF.URL_FEEDBACK,
    isAllowed: () => true
};

export const navigateToSupport = {
    path: CONF.URL_SUPPORT,
    isAllowed: () => true
};

export const navigateToTeams = {
    path: `${CONF.BASE_URL_APP}/teams`,
    isAllowed: () => true
};

export const navigateToLegacySubscriptionPlans = {
    path: `${CONF.URL_COACHHEROIC}/settings/billing/subscription`,
    isAllowed: () => true
};

export const navigateToSubscriptionPlans = {
    path: `${CONF.URL_ACCOUNT}/subscription-plans`,
    isAllowed: () => true
};

export const navigateToAssistantCoaches = {
    path: `${CONF.URL_ACCOUNT}/assistant-coaches`,
    isAllowed: () => true
};

export const navigateToIntegrations = {
    path: `${CONF.URL_ACCOUNT}/integrations`,
    isAllowed: () => true
};

export const navigateToAttributions = {
    path: `/my-store/attribution-links`,
    isAllowed: () => true
};

export const publishSession = {
    isAllowed: () => !isBasic()
};

export const navigateToTeamFeed = {
    path: `${CONF.URL_COACHHEROIC}/team/feed/`,
    isAllowed: () => true
};

export const navigateToAthleteFeed = {
    path: `${CONF.URL_COACHHEROIC}/athlete/feed/`,
    isAllowed: () => true
};
